var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sys-teacher-hub-modal",
    {
      attrs: {
        show: _vm.localShow,
        title: _vm.title,
        icon: "mdi-clipboard-outline",
      },
      on: {
        "update:show": function ($event) {
          _vm.localShow = $event
        },
      },
    },
    [
      _c(
        "v-card-text",
        { staticClass: "pa-4" },
        [
          !_vm.loading && _vm.items.length === 0
            ? _c(
                "v-alert",
                { staticClass: "mb-0", attrs: { type: "info", outlined: "" } },
                [_vm._v(" Nenhuma atividade cadastrada para este período. ")]
              )
            : _vm._e(),
          _vm.loading
            ? _c("emc-base-progress-bar")
            : _vm.items.length > 0
            ? _c("v-simple-table", {
                attrs: { dense: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function () {
                      return [
                        _c("thead", [
                          _c("tr", [
                            _c("th", { attrs: { scope: "col" } }, [
                              _vm._v("Campus/Departamento"),
                            ]),
                            _c("th", { attrs: { scope: "col" } }, [
                              _vm._v("Atividade"),
                            ]),
                            _c("th", { attrs: { scope: "col" } }, [
                              _vm._v("Nome"),
                            ]),
                            _c("th", { attrs: { scope: "col" } }, [
                              _vm._v("Periodicidade"),
                            ]),
                            _c("th", { attrs: { scope: "col" } }, [
                              _vm._v("Tipo"),
                            ]),
                            _c(
                              "th",
                              {
                                staticClass: "text-center",
                                attrs: { scope: "col" },
                              },
                              [_vm._v("Valor")]
                            ),
                            _c(
                              "th",
                              {
                                staticClass: "text-center",
                                attrs: { scope: "col" },
                              },
                              [_vm._v("Compõe CH")]
                            ),
                            _c(
                              "th",
                              {
                                staticClass: "text-center",
                                attrs: { scope: "col" },
                              },
                              [_vm._v("Período")]
                            ),
                            _c(
                              "th",
                              {
                                staticClass: "text-center",
                                attrs: { scope: "col" },
                              },
                              [_vm._v("Status")]
                            ),
                          ]),
                        ]),
                        _c(
                          "tbody",
                          _vm._l(_vm.items, function (item) {
                            return _c("tr", { key: item.id }, [
                              _c("td", [
                                item.activityItem && item.activityItem.campus
                                  ? _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            item.activityItem.campus.name
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : item.activityItem &&
                                    item.activityItem.departament
                                  ? _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            item.activityItem.departament.name
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _c("span", [_vm._v("-")]),
                              ]),
                              _c("td", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      item.activityItem &&
                                        item.activityItem.activity
                                        ? item.activityItem.activity.name
                                        : "-"
                                    ) +
                                    " "
                                ),
                              ]),
                              _c("td", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      item.activityItem
                                        ? item.activityItem.name
                                        : "-"
                                    ) +
                                    " "
                                ),
                              ]),
                              _c("td", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      item.activityItem &&
                                        item.activityItem.periodicityType
                                        ? item.activityItem.periodicityType.name
                                        : "-"
                                    ) +
                                    " "
                                ),
                              ]),
                              _c("td", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      item.activityItem &&
                                        item.activityItem.valueType
                                        ? item.activityItem.valueType.name
                                        : "-"
                                    ) +
                                    " "
                                ),
                              ]),
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(_vm._s(item.value || "-")),
                              ]),
                              _c(
                                "td",
                                { staticClass: "text-center" },
                                [
                                  item.activityItem &&
                                  item.activityItem.activity &&
                                  item.activityItem.activity.is_work_load
                                    ? _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "success",
                                          },
                                        },
                                        [_vm._v(" mdi-check-bold ")]
                                      )
                                    : _c(
                                        "v-icon",
                                        {
                                          attrs: { small: "", color: "error" },
                                        },
                                        [_vm._v("mdi-close-thick")]
                                      ),
                                ],
                                1
                              ),
                              _c(
                                "td",
                                { staticClass: "text-center text-no-wrap" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm._f("date")(item.start)) +
                                      " - " +
                                      _vm._s(_vm._f("date")(item.end)) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "td",
                                { staticClass: "text-center" },
                                [
                                  item.activityItem && item.activityItem.status
                                    ? _c(
                                        "v-chip",
                                        {
                                          attrs: {
                                            "x-small": "",
                                            color: _vm.getStatusColor(
                                              item.activityItem
                                                .activity_item_status_id
                                            ),
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                item.activityItem.status.name
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ])
                          }),
                          0
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              })
            : _vm._e(),
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-card-actions",
        [
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: { text: "" },
              on: {
                click: function ($event) {
                  return _vm.$emit("update:show", false)
                },
              },
            },
            [_vm._v("Fechar")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }